import Form from '@arivaa-react/components/form';

export function EditHeaderCta() {
  const handleSubmit = async (values) => {
    console.log(values);
  };
  return (
    <div className="card navigation">
      <div className="heading">
        <p className="label">Edit Call to Action Button</p>
      </div>
      <div className="edit-form">
        <Form
          renderForm={({ renderElement }) => {
            return (
              <div>
                <div className="item">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Button Text',
                    required: true,
                    options: {
                      initialValue: '',
                    },
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'select',
                    name: 'type',
                    label: 'On Click take user to',
                    required: true,
                    data: ['Page', 'Link'],
                    options: {
                      initialValue: 'Yes',
                    },
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'select',
                    name: 'type',
                    label: 'Select Page',
                    required: true,
                    data: ['Page 1', 'Page 2'],
                    options: {
                      initialValue: 'Yes',
                    },
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Enter Link',
                    required: true,
                    options: {
                      initialValue: '',
                    },
                  })}
                </div>
              </div>
            );
          }}
          onSubmit={handleSubmit}
          submitButtonProps={{
            children: 'Save',
          }}
        />
      </div>
    </div>
  );
}
